var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z",
    fill: "#0E6EFD",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z",
    fill: "#0E6EFD"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0E6EFD",
    opacity: 0.3,
    x: 10,
    y: 9,
    width: 7,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0E6EFD",
    opacity: 0.3,
    x: 7,
    y: 9,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0E6EFD",
    opacity: 0.3,
    x: 7,
    y: 13,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0E6EFD",
    opacity: 0.3,
    x: 10,
    y: 13,
    width: 7,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0E6EFD",
    opacity: 0.3,
    x: 7,
    y: 17,
    width: 2,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#0E6EFD",
    opacity: 0.3,
    x: 10,
    y: 17,
    width: 7,
    height: 2,
    rx: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.bfe2d5518886e3efa826806b44c063b3.svg";
export { ForwardRef as ReactComponent };